<template>
    <div>
        <v-row wrap>
            <v-col cols="12">
                <v-select label="Content Type" :items="content_types" v-model="content_type"></v-select>
            </v-col>
            <v-col cols="12" v-if="value && content_type && value.block">
                <div :is="content_type + '-editor'" v-model="value.block"></div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import WistiaVideoGroupEditor from '@/CMS/editor/components/editors/SummitWistiaVideoGroupEditor.vue'
import FullWidthTextEditor from '@/CMS/editor/components/editors/FullWidthTextEditor.vue'
export default {
    name: "QStepContentEditor",
    props: {
        value: {
            type: Object,
            default: function() {
                return {
                    type: 'wistia-video-group',
                    block: {
                        Videos: [{
                            id: this.counter,
                            title: "",
                            video_id: "",
                            text: "",
                            buttonText: "",
                            buttonHref: "",
                            newWindow: true,
                        }],
                        NumColumns: 1
                    }
                }
            }
        },
    },

    data() {
        return {
            saving: false,
            warning: null,
            error: null,
            valid: false,
            content_type: null,
            content_types: [{
                    text: "Wistia Video",
                    value: "wistia-video-group"
                },
                {
                    text: "Text",
                    value: "full-width-text"
                }
            ]
        };
    },

    mounted() {
        if (this.value != null) {
            this.content_type = this.value.type
        } else {
            //this.content_type = "full-width-text"
        }
    },

    created: function() {

    },

    methods: {

    },

    watch: {
        'content_type': function(newV, oldV) {
            if (oldV == null && this.value != null) {
                return
            }
            var c = {}
            switch (newV) {
                case "wistia-video-group":
                    c = {
                        type: 'wistia-video-group',
                        block: {
                            Videos: [{
                                id: this.counter,
                                title: "",
                                video_id: "",
                                text: "",
                                buttonText: "",
                                buttonHref: "",
                                newWindow: true,
                            }],
                            NumColumns: 1
                        }
                    }
                    break;
                case "calculator":
                    c = {
                        type: 'calculator',
                        block: {

                        }
                    }
                    break;
                case "full-width-text":
                    c = {
                        type: 'full-width-text',
                        block: {
                            'text': "Put some copy here.",
                            'Title': "Need Another Title?"
                        }
                    }
                    break;
            }
            this.$emit("input", c)
        }
    },
    components: {
        WistiaVideoGroupEditor,
        FullWidthTextEditor
    }

}

</script>
<style scoped>
</style>
